export const INACTIVE_USER_VISIBLE_DAYS = 30
